export const getMoneyFormatter = (options?: Intl.NumberFormatOptions) => new Intl.NumberFormat(site.culture.uiLocale, {
  style: "decimal",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  ...options,
});

export const getPercentageFormatter = (decimalDigits: number) => new Intl.NumberFormat(site.culture.uiLocale, {
  style: "percent",
  maximumFractionDigits: decimalDigits
});

export const getNumberFormatter = () => new Intl.NumberFormat(site.culture.uiLocale);

export const formatUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url);

    return parsedUrl.hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}